import {
  ButtonV3,
  GridItem,
  InverseHeader,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const SizingPageHero = (): JSX.Element => {
  const t = useTranslations();
  const modalContext = useSizingPageModalContext();

  const onWatchGen4VideoClick = () => {
    modalContext.setOr4VideoVisible(true);
  };

  const onWatchGen3VideoClick = () => {
    modalContext.setOr3VideoVisible(true);
  };

  return (
    <InverseHeader enter>
      <section className="relative h-screen lg:h-[540px]" data-cy="sizing-hero">
        <div className="absolute inset-0">
          <LayoutGrid className="size-full">
            <GridItem
              colEnd={{ sm: 'full' }}
              colStart={{ sm: 'full' }}
              rowEnd={{ sm: 2 }}
              rowStart={{ sm: 1 }}
            >
              <div className="mx-auto size-full max-w-[1560px] lg:px-5">
                <div className="relative size-full overflow-hidden lg:rounded-b-lg">
                  <ArtDirectionImage
                    className="object-cover lg:object-bottom"
                    fill
                    localizedAlt="sizing_gen4_hero_img_alt"
                    srcSet={[
                      {
                        media: '(max-width: 1023px)',
                        src: 'blue-sky/sizing/or4-sizing-hero.jpg?ar=4:3&fit=crop&crop=focalpoint&fp-x=0.45&fp-y=0.5fp-z=1&exp=5&con=-10',
                      },
                      {
                        media: '(min-width: 1024px)',
                        src: 'blue-sky/sizing/or4-sizing-hero.jpg?ar=16:9&fit=crop&crop=focalpoint&fp-x=0.35&fp-y=0.6&fp-z=1.1&exp=5&con=-10',
                      },
                    ]}
                  />
                </div>
              </div>
            </GridItem>
            <GridItem
              className="relative z-10 flex h-full flex-col pb-12 pt-36 maxlg:items-center"
              colEnd={{ sm: 'main' }}
              colStart={{ sm: 'main' }}
              rowEnd={{ sm: 2 }}
              rowStart={{ sm: 1 }}
            >
              <TypographyV3
                className="mb-2 uppercase tracking-wider lg:mb-6"
                color="light"
                Element="h1"
                weight="bold"
              >
                {t('sizing_gen4_hero_eyebrow')}
              </TypographyV3>
              <TypographyV3
                className="mb-10 leading-tighter lg:mb-auto"
                color="light"
                Element="h2"
                variant="h2"
              >
                {t('sizing_gen4_hero_title')}
              </TypographyV3>
              <div className="flex flex-col items-center gap-5 lg:flex-row lg:gap-6">
                <ButtonV3
                  onClick={onWatchGen4VideoClick}
                  data-cy="sizing-hero-gen4-video-cta"
                  variant="secondary-light"
                >
                  {t('sizing_gen4_or4_video_label')}
                </ButtonV3>
                <button
                  className="text-sandstone-200 underline"
                  data-cy="sizing-hero-gen3-video-cta"
                  onClick={onWatchGen3VideoClick}
                >
                  {t('sizing_gen4_or3_video_label')}
                </button>
              </div>
            </GridItem>
          </LayoutGrid>
        </div>
      </section>
    </InverseHeader>
  );
};

export default SizingPageHero;
